<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Список клиентов"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-account"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          База клиентов
        </div>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Поиск"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-by="['surname', 'name', 'category_text']"
        :sort-desc="[false]"
        multi-sort
      >
        <template v-slot:item.view="{item}">
          <v-row>
            <v-col cols="12">
              <v-icon
                color="warning"
                large
                @click="$router.push('/clients/view/' + item.id)"
              >
                mdi-cog
              </v-icon>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="$router.push('/contract/create/' + item.id)"
          >
            mdi-file-document-box-plus
          </v-icon>
        </template>
        <!--<template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date.from"
                    label="Дата начала"
                    type="date"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date.to"
                    label="Дата конца"
                    type="date"
                  />
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="load"
                  >
                    Поиск
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>-->
      </v-data-table>
      <v-card-actions>
        <v-btn
          v-if="$store.state.user.role == 1 || $store.state.user.role == 2 || $store.state.user.role == 5"
          color="primary"
          min-width="100"
          @click="$router.push('/clients/create')"
        >
          Создать
        </v-btn>
      </v-card-actions>
    </base-material-card>
  </v-container>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      datatable_footer: {
        itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', pageText: 'из'
      },
      headers: [
        {
          text: '',
          value: 'view',
        },
        {
          text: 'Фамилия',
          value: 'surname',
        },
        {
          text: 'Имя',
          value: 'name',
        },
        {
          text: 'Отчество',
          value: 'patronymic',
        },
        {
          text: 'Адрес',
          value: 'address',
        },
        {
          text: 'Категория',
          value: 'category_text',
        },
        {
          text: 'Серия ВУ',
          value: 'doc.series',
        },
        {
          text: 'Номер ВУ',
          value: 'doc.number',
        },
      ],
      items: [],
      search: undefined,
      form: {
        date: {
          from: '',
          to: '',
        },
      },
      dict: {
        category: {
          1: 'A',
          2: 'A1',
          3: 'B',
          4: 'BE',
          5: 'B1',
          6: 'C',
          7: 'CE',
          8: 'C1',
          9: 'C1E',
          10: 'D',
          11: 'DE',
          12: 'D1',
          13: 'D1E',
          14: 'M',
          15: 'Tm',
          16: 'Tb',
        },
      },
    }),
    mounted: function () {
      this.load()
    },
    methods: {
      load: function () {
        this.axios.post('/api/clients/list', this.form)
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                result.data.data[x].category_text = ''
                for (let y in result.data.data[x].category) {
                  result.data.data[x].category_text += this.dict.category[result.data.data[x].category[y]]
                }
              }
              this.items = result.data.data
            }
          })
          .catch(e => {

          })
      },
    },
  }
</script>
